var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickBlue = function SvgTickBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07367 10C4.76344 10 4.44997 9.88312 4.21283 9.64776L0.356923 5.84838C-0.118974 5.37926 -0.118974 4.62034 0.356923 4.15122C0.832821 3.6821 1.6027 3.6821 2.0786 4.15122L5.07367 7.10043L11.9214 0.351839C12.3973 -0.11728 13.1672 -0.11728 13.6431 0.351839C14.119 0.820958 14.119 1.57987 13.6431 2.04899L5.93451 9.64776C5.69737 9.88312 5.38552 10 5.07367 10Z",
    fill: "#2355FC"
  })));
};
export default SvgTickBlue;